export interface UnavailabilityIntervalsArgs {
    type: TargetTypes;
    alias: string;
}

export enum TargetTypes {
    Crane = 'Crane',
    Resource = 'Resource',
    Vehicle = 'Vehicle'
}
